import React from 'react';
import Header from '../HeaderSection/HeaderMobiCloud';
import FooterSection from '../FooterSection/FooterMobiCloud';

const TermsOfService = () => {
    return (
        <div>
            <Header imageData={"/img/logo-white.png"} />
            
            <section className="section pt-5 mt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <div className="text-center mb-5">
                                <h1 className="mb-4">Terms of Service</h1>
                                <p className="text-muted">Last updated: December 2024</p>
                            </div>
                            
                            <div className="content">
                                <h2>1. Acceptance of Terms</h2>
                                <p>By accessing and using the MobiCloud website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
                                
                                <h2>2. Description of Service</h2>
                                <p>MobiCloud provides technology solutions including but not limited to:</p>
                                <ul>
                                    <li>Cloud services and migration</li>
                                    <li>Mobile application development</li>
                                    <li>AI and machine learning solutions</li>
                                    <li>Digital transformation consulting</li>
                                    <li>Application development services</li>
                                    <li>Engineering services</li>
                                </ul>
                                
                                <h2>3. Use License</h2>
                                <p>Permission is granted to temporarily download one copy of the materials (information or software) on MobiCloud's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
                                <ul>
                                    <li>Modify or copy the materials</li>
                                    <li>Use the materials for any commercial purpose or for any public display</li>
                                    <li>Attempt to decompile or reverse engineer any software contained on the website</li>
                                    <li>Remove any copyright or other proprietary notations from the materials</li>
                                    <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                                </ul>
                                
                                <h2>4. Disclaimer</h2>
                                <p>The materials on MobiCloud's website are provided on an 'as is' basis. MobiCloud makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
                                
                                <h2>5. Limitations</h2>
                                <p>In no event shall MobiCloud or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on MobiCloud's website, even if MobiCloud or a MobiCloud authorized representative has been notified orally or in writing of the possibility of such damage.</p>
                                
                                <h2>6. Accuracy of Materials</h2>
                                <p>The materials appearing on MobiCloud's website could include technical, typographical, or photographic errors. MobiCloud does not warrant that any of the materials on its website are accurate, complete, or current. MobiCloud may make changes to the materials contained on its website at any time without notice.</p>
                                
                                <h2>7. Links</h2>
                                <p>MobiCloud has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by MobiCloud of the site. Use of any such linked website is at the user's own risk.</p>
                                
                                <h2>8. Modifications</h2>
                                <p>MobiCloud may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms of Service.</p>
                                
                                <h2>9. Governing Law</h2>
                                <p>These terms and conditions are governed by and construed in accordance with the laws of the United States and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
                                
                                <h2>10. Intellectual Property</h2>
                                <p>All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of MobiCloud and is protected by copyright laws. Any unauthorized use of this content may violate copyright, trademark, and other applicable laws.</p>
                                
                                <h2>11. User Conduct</h2>
                                <p>You agree not to use the service to:</p>
                                <ul>
                                    <li>Violate any applicable laws or regulations</li>
                                    <li>Infringe upon the rights of others</li>
                                    <li>Transmit harmful, offensive, or inappropriate content</li>
                                    <li>Attempt to gain unauthorized access to our systems</li>
                                    <li>Interfere with the proper functioning of the service</li>
                                </ul>
                                
                                <h2>12. Termination</h2>
                                <p>We may terminate or suspend your access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
                                
                                <h2>13. Contact Information</h2>
                                <p>If you have any questions about these Terms of Service, please contact us at:</p>
                                <div className="contact-info mt-3">
                                    <p><strong>Email:</strong> legal@mobicloud.ai</p>
                                    <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                                    <p><strong>Address:</strong> 123 Tech Street, Silicon Valley, CA 94025</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <FooterSection />
        </div>
    );
};

export default TermsOfService; 